import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import Home from './pages/Home';
import SmallBusiness from './pages/SmallBusiness';
import BusinessOwnersPolicy from './pages/BusinessOwnersPolicy';
import GeneralLiability from './pages/GeneralLiability';
import ProfessionalLiability from './pages/ProfessionalLiability';
import CyberInsurance from './pages/CyberInsurance';
import WorkplaceViolence from './pages/WorkplaceViolence';
import WorkersComp from './pages/WorkersComp';
import About from './pages/About';
import Contact from './pages/Contact';

// City-specific pages
import LosAngeles from './pages/cities/LosAngeles';
import SanFrancisco from './pages/cities/SanFrancisco';
import SanDiego from './pages/cities/SanDiego';
import Sacramento from './pages/cities/Sacramento';
import SanJose from './pages/cities/SanJose';
import Irvine from './pages/cities/Irvine';

import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/small-business-insurance" element={<SmallBusiness />} />
            <Route path="/business-owners-policy" element={<BusinessOwnersPolicy />} />
            <Route path="/general-liability" element={<GeneralLiability />} />
            <Route path="/professional-liability" element={<ProfessionalLiability />} />
            <Route path="/cyber-insurance" element={<CyberInsurance />} />
            <Route path="/workplace-violence" element={<WorkplaceViolence />} />
            <Route path="/workers-compensation" element={<WorkersComp />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* City-specific routes */}
            <Route path="/small-business-insurance-los-angeles" element={<LosAngeles />} />
            <Route path="/small-business-insurance-san-francisco" element={<SanFrancisco />} />
            <Route path="/small-business-insurance-san-diego" element={<SanDiego />} />
            <Route path="/small-business-insurance-sacramento" element={<Sacramento />} />
            <Route path="/small-business-insurance-san-jose" element={<SanJose />} />
            <Route path="/small-business-insurance-irvine" element={<Irvine />} />
            <Route path="/small-business-insurance-fresno" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-long-beach" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-oakland" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-bakersfield" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-anaheim" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-santa-ana" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-riverside" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-stockton" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-chula-vista" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-fremont" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-san-bernardino" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-modesto" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-fontana" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-oxnard" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-moreno-valley" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-huntington-beach" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-glendale" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-santa-clarita" element={<SmallBusiness />} />
            <Route path="/small-business-insurance-garden-grove" element={<SmallBusiness />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </Router>
  );
}

export default App;